import { TextField, SelectField } from '../forms';
import {
  createMaturityFrameworkSchema,
  type CreateMaturityFrameworkFormData,
} from '../forms/validation';
import { EntityForm } from '../shared';
import '@tylertech/forge/card';
import './MaturityFrameworkForm.css';

export interface MaturityFrameworkFormProps {
  defaultValues?: Partial<CreateMaturityFrameworkFormData>;
  onSubmit: (data: CreateMaturityFrameworkFormData) => void | Promise<void>;
  onCancel: () => void;
  isSubmitting?: boolean;
  mode: 'create' | 'edit';
}

const statusOptions = [
  { value: 'Draft', label: 'Draft' },
  { value: 'Active', label: 'Active' },
  { value: 'Deprecated', label: 'Deprecated' },
];

const CardElement = 'forge-card' as React.ElementType;

export function MaturityFrameworkForm({
  defaultValues,
  onSubmit,
  onCancel,
  isSubmitting = false,
  mode,
}: MaturityFrameworkFormProps): JSX.Element {
  return (
    <EntityForm<CreateMaturityFrameworkFormData>
      schema={createMaturityFrameworkSchema}
      baseValues={{ status: 'Draft' }}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
      mode={mode}
      createLabel="Create Framework"
      editLabel="Update Framework"
      formClassName="maturity-framework-form"
      actionsClassName="maturity-framework-form__actions"
      noValidate
    >
      {({ register, formState: { errors } }) => (
        <CardElement className="maturity-framework-form__card">
          <div className="maturity-framework-form__section">
            <h3 className="forge-typography--subtitle1">Framework Details</h3>

            <TextField label="Framework Name" {...register('name')} error={errors.name} required />

            <TextField
              label="Description"
              {...register('description')}
              error={errors.description}
            />

            <div className="maturity-framework-form__row">
              <TextField
                label="Version"
                {...register('version')}
                error={errors.version}
                placeholder="e.g. 1.0"
                required
              />

              <SelectField
                label="Status"
                {...register('status')}
                error={errors.status}
                options={statusOptions}
              />
            </div>

            <div className="maturity-framework-form__row">
              <TextField
                label="Effective From"
                {...register('effectiveFrom')}
                error={errors.effectiveFrom}
                type="date"
                required
              />

              <TextField
                label="Effective To"
                {...register('effectiveTo')}
                error={errors.effectiveTo}
                type="date"
              />
            </div>
          </div>
        </CardElement>
      )}
    </EntityForm>
  );
}
